import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { IDefaultResponse } from "../../models/DefaultResponse";
import { ICustomer } from "../../models/Customer/Customer";
import { CategoryQueryKeys } from "./keys";
import { IPartCategory } from "../../models/Category/Category";

// [FromQuery] string searchTerm = "", 
// [FromQuery] int pageNumber = 0, 
// [FromQuery] int itemsPerPage = 50, 
// [FromQuery] bool includeDeleted = false

export interface IUseCategoriesProps {
  searchTerm?: string;
  pageNumber?: number;
  itemsPerPage?: number;
  includeDeleted?: boolean;
}

export default function useCategories({ searchTerm, pageNumber, itemsPerPage, includeDeleted }: IUseCategoriesProps) {
  const { get } = useApiHelper();
  const params: Record<string, string> = {};

  if (searchTerm    ) params.searchTerm     = searchTerm;
  if (pageNumber    ) params.pageNumber     = pageNumber.toString();
  if (itemsPerPage  ) params.itemsPerPage   = itemsPerPage.toString();
  if (includeDeleted) params.includeDeleted = includeDeleted.toString();
  const queryString = new URLSearchParams(params).toString();

  const categories = useQuery({
    queryKey: CategoryQueryKeys.all(),
    queryFn: () =>
      get<IDefaultResponse<IPartCategory[]>>(`/part/categories?${queryString}`).then((res) => res.data),
  });

  return {
    categories,
  };
}
